import { render, staticRenderFns } from "./Versoes.vue?vue&type=template&id=4a147bae&scoped=true&"
import script from "./Versoes.vue?vue&type=script&lang=js&"
export * from "./Versoes.vue?vue&type=script&lang=js&"
import style0 from "./Versoes.vue?vue&type=style&index=0&id=4a147bae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a147bae",
  null
  
)

export default component.exports